import TradePageOrderHistoryTable from 'src/components/HistoryTables/TradePageOrderHistoryTable/TradePageOrderHistoryTable';
import { PORTFOLIO_HISTORY_TABLE_EMPTY_CLASSNAME } from 'src/components/PortfolioPage/PortfolioHistorySubPage/consts';

export default function PortfolioHistoryOrdersTable() {
	return (
		<>
			<TradePageOrderHistoryTable
				className="rounded-sm sm:bg-container-bg"
				tableContentWrapperClassName="not-sm:px-0"
				filtersWrapperClassName="not-sm:px-0 not-sm:border-0"
				emptyClassName={PORTFOLIO_HISTORY_TABLE_EMPTY_CLASSNAME}
			/>
		</>
	);
}
